import locale from "localization";

export const viewPremiumPayoutColumns = [
  { key: "redemptionStation", text: locale.redemptionStation, width: "24%" },
  { key: "totalLiters", text: locale.totalLiterRedemption, width: "24%" },
  { key: "totalPayPeso", text: locale.totalPayPeso, width: "24%" },
  { key: "totalPremium", text: locale.totalPremium, width: "24%" },
  { key: "action", text: locale.action, width: "4%" },
];
